<template>
    <v-container class="device-verification text-left" fluid>
        <HkiaraceBannerFrame :label="$t('device_verification.title')">
            <v-container class="device-verification-container">
                <v-row>
                    <v-col>
                        <v-row>
                            <v-col>{{$t('device_verification.content')}}</v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field outlined
                                              class="required"
                                              :label="$t('device_verification.second_factor_code')"
                                              :placeholder="$t('device_verification.second_factor_code')"
                                              v-model="secondFactorCode"
                                              @keyup.enter="verify">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox v-model="rememberDevice"
                                            :label="$t('device_verification.remember_device')">

                                </v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-btn block color="primary" @click="verify">
                                    {{$t('continue')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </HkiaraceBannerFrame>

    </v-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";
    import { deviceVerificationErrorHandler } from '@/plugins/errorHandler';

    library.add(faEnvelope);

    export default {
        name: 'DeviceVerification',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                secondFactorCode: '',
                rememberDevice: false,
                after: this.$route.query.after,
                oauthNextUrl: this.$route.query.next
            };
        },
        watch: {
            currentUser(newVal, oldVal) {
                if (!oldVal.id && newVal.id) {
                    // let idExpiryDate = newVal.id_expiry_date ? DateTime.fromISO(newVal.id_expiry_date) : null;
                    //
                    // // if (newVal.type === 369 || newVal.type === 100) {
                    // //     this.$router.replace({name: 'acc-booking'});
                    // // } else
                    //
                    // if (!newVal.id_no || (idExpiryDate && new Date() > idExpiryDate)) {
                    //     this.$router.replace({name: 'id-verify', query: {after: this.after}});
                    // } else

                    if (this.after) {
                        this.$router.replace({path: this.after});
                    } else {
                        this.$router.replace({name: 'my-account'});
                    }
                }
            },
        },
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
        },
        methods: {
            verify() {
                if (this.secondFactorCode) {
                    this.$callAPI('hkiarace/device_verify/', {second_factor_code: this.secondFactorCode, remember_device: this.rememberDevice},
                        // Success
                        function (response) {
                          if (this.oauthNextUrl) {
                            window.location.href = this.oauthNextUrl.startsWith("/")
                                ? window.location.origin + this.oauthNextUrl
                                : this.oauthNextUrl;
                          }
                          else {
                            this.$storeDispatch('getMe');
                          }
                        },
                        //Failure
                        function (response) {
                          deviceVerificationErrorHandler(response, this);
                        },
                    );
                }
            },
        }
    }
</script>

<style lang="less">
    .device-verification {
        .device-verification-container {
            padding: 54px 10% 24px 10%;
            background-color: white;

            .v-input {
                border-radius: 0;
            }
        }

        .device-verification-title {
            font-weight: bold;
            font-size: 1.3rem;
        }
    }
</style>
